import React from 'react';
import { DateTime } from 'luxon';

import withStyles from '@mui/styles/withStyles';

import { dateStringForDateTime } from '../utils/utils';

import activitySummaryBoxStyles from '../assets/jss/crm/components/activitySummaryBoxStyles';

class ActivitySummaryBox extends React.Component {
  render() {
    const { classes, nInteractions, lastInteractionTime, status } = this.props;
    const lastInteractionDateString = dateStringForDateTime(lastInteractionTime);
    const daysSince = lastInteractionTime ? (DateTime.local() - lastInteractionTime).days : '';
    return (
      <div className={classes.root}>
        <div className={classes.items + ' ' + classes.u_boxShadow}>
          <div className={classes.item + ' ' + classes.interactionCount}>
            <div className={classes.itemNumber + ' ' + classes.as_darkText}>
              <strong>{nInteractions}</strong>
            </div>
            <div className={classes.itemLabel + ' ' + classes.as_grayText}>Interactions</div>
          </div>
          <div className={classes.item + ' ' + classes.lastInteractionDate}>
            <div className={classes.itemNumber + ' ' + classes.as_darkText}>
              <strong>{lastInteractionDateString ? lastInteractionDateString : <br />}</strong>
            </div>
            <div className={classes.itemLabel + ' ' + classes.as_grayText}>Last Contacted</div>
          </div>
          {status !== 'Client' && (
            <div className={classes.item + ' ' + classes.inactiveDays}>
              <div className={classes.itemNumber + ' ' + classes.as_darkText}>
                <strong>{daysSince ? daysSince : <br />}</strong>
              </div>
              <div className={classes.itemLabel + ' ' + classes.as_grayText}>Inactive Days</div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withStyles(activitySummaryBoxStyles)(ActivitySummaryBox);
